import mask from 'jquery.maskedinput/src/jquery.maskedinput';
import openFormStatus from '../form/form';

$("#userContactPhone").mask("+7 (999) 999-99-99");

$('#formUserContact').submit(event => {
  event.preventDefault();

  const userName = $("#userContactName").val();
  const userPhone = $("#userContactPhone").val();
  const userComment = $("#userContactComment").val();

  $.post('https://api.groupw.ru/mtrend/demands/join/person', {

    phone: userPhone,
    name: userName,
    comment: userComment,
    demandSource: 'Заявка с сайта'

  }, response => {
    console.log(response);

    openFormStatus('Заявка принята', 'Наш сотрудник позвонит Вам <br>в течение 10 минут.');
  });
});



// WEBPACK FOOTER //
// ./app/blocks/form-contact/form-contact.js